import Vue from 'vue'
import op from 'object-path'
/* epayType优惠支付类型 */
Vue.filter('epayType', (str) => {
  switch (+str) {
    case 0:
      return '优惠'
    case 1:
      return '积分'
    case 2:
      return '积分'
    case 3:
      return '现金券'
    case 4:
      return '苏打券'
    default:
      return ''
  }
});
// 优先赔状态文案
// Vue.filter('youxianpeiText', function (value) {
//     switch (value) {
//         case 0:
//         case 3:
//         // case 8:
//             return "退款中";
//         case 5:
//             // if (serviceType)
//             return "补货完成";
//         case 6:
//             return "退款完成";
//         case 14:
//             return '退款完成';
//         case 8:
//             return '退款中';
//         case 9:
//             return '';
//         default:
//             return "退换中";
//     }
// });
/* 售后状态 */
Vue.filter('serviceStatusText', (value) => {
  switch (value) {
        // case 3:
        //     return "退款中";
    case 4:
      return '售后关闭';
    case 5:
      return '已换货';
    case 6:
      return '已退款';
    case 9:
      return '售后取消';
        // default:
        //     return "退换中";
    default:
      return '售后中';
  }
});
/* 签收状态 */
Vue.filter('deliveryStatus', (value) => {
  switch (value.logisticsStatus) {
    case 1:
      return '已签收';
    case 0:
      const trace = value.traceList
                ? op(value.traceList[value.traceList.length - 1]).get(
                    'acceptStation',
                ) || ''
                : '';
      return trace;
    default:
      return '';
  }
})
/* 签收时间 */
Vue.filter('acceptTime', (value) => {
  if (value) {
    const lastValue = value[value.length - 1]

    if (lastValue) {
      return value[value.length - 1].acceptTime
    }
    return ''
  }
  return ''
})

